<script lang="ts">
    import {Flex, Spacer} from 'shared/layouts';
    import {getLocalization} from 'src/core';
    import {KpPopover, type TogglePopoverFn} from 'shared/ui-widgets/popover';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {get} from 'svelte/store';
    import {callCommand} from '@milkdown/utils';
    import {isFunction} from 'shared/utils/custom-utils';
    import {ValueEditorSize} from 'shared/value-editors/types';
    import {insertImageCommand} from '@milkdown/preset-commonmark';
    import ToolbarButton from './ToolbarButton.svelte';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();

    let url = '';
    let togglePopover: TogglePopoverFn;

    function insertImage() {
        const editor = get(editor$);
        if (!editor) {
            return;
        }

        editor.action(
            callCommand(insertImageCommand.key, {src: url})
        );

        if (isFunction(togglePopover)) {
            togglePopover(false);
        }
    }

    const handlePopoverClose = () => {
        url = '';
    };
</script>

<KpPopover on:popover-close={handlePopoverClose} bind:togglePopover>
    <svelte:fragment slot="whole-button" let:buttonId let:panelId let:floatingRef>
        <ToolbarButton icon="add-image"
                       id={buttonId}
                       tooltipLabel={localize(/* @kp-localization richTextArea.tools.image */ 'richTextArea.tools.image')}
                       popovertarget={panelId}
                       use={[floatingRef]}/>
    </svelte:fragment>

    <svelte:fragment slot="popover-content">
        <Flex direction="column">
            <KpValueEditor type="text" size={ValueEditorSize.SM} placeholder="URL" bind:model={url}/>
            <Spacer direction="vertical" size="m"/>

            <KpButton buttonSize="sm" isDisabled={!url || url.trim() === ''} on:click={insertImage}>
                {localize(/* @kp-localization richTextArea.tools.image */ 'richTextArea.tools.image')}
            </KpButton>
        </Flex>
    </svelte:fragment>
</KpPopover>
